import reactHotToast from "react-hot-toast";
import { ToastContent } from "./toast-content";
import type { Variant } from "./variant";

type ToastOptions = Parameters<(typeof reactHotToast)["custom"]>[1] & {
  dataTestId?: string;
};

const Toast: FC<{
  id: string;
  message: string;
  variant: Variant;
  dataTestId?: string;
}> = ({ id, message, variant, dataTestId }) => (
  <ToastContent
    key={id}
    message={message}
    variant={variant}
    onClose={() => reactHotToast.dismiss(id)}
    dataTestId={dataTestId}
  />
);

export const toast = {
  success: (m: string, o: ToastOptions = {}) => showToast("success", m, o),
  info: (m: string, o: ToastOptions = {}) => showToast("info", m, o),
  warning: (m: string, o: ToastOptions = {}) => showToast("warning", m, o),
  error: (m: string, o: ToastOptions = {}) => showToast("error", m, o),
  loading: (m: string, o: ToastOptions = {}) => showToast("loading", m, o),
  offline: (m: string, o: ToastOptions = {}) => showToast("offline", m, o),
  remove: (toastId?: string) => reactHotToast.remove(toastId),
};

const showToast = (
  variant: Variant,
  message: string,
  options: ToastOptions = {},
) =>
  reactHotToast.custom(
    (t) => (
      <Toast
        id={t.id}
        message={message}
        variant={variant}
        dataTestId={options.dataTestId}
      />
    ),
    options,
  );
